// 下拉選單是客製化，因此沒辦法直接抓值

function bindOneDropdown (dropdown, optionsChanged) {
  if (optionsChanged) {
    if (document.querySelector('.countries-select .select-selected')) document.querySelector('.countries-select .select-selected').remove()
    if (document.querySelector('.countries-select .select-items')) document.querySelector('.countries-select .select-items').remove()
    // if (document.querySelector('.countries-select .select-selected')) document.querySelector('.countries-select .select-selected').setAttribute('class', 'select-hide')
    // if (document.querySelector('.countries-select .select-items')) document.querySelector('.countries-select .select-items').setAttribute('class', 'select-hide')
    document.querySelector('.countries-select select').selectedIndex = 0
  }

  // console.log(this)
  var vue = this.$root
  console.log('bindOneDropdown')
  // start
  var x, i, j, selElmnt, a, b, c
  selElmnt = dropdown.getElementsByTagName('select')[0]
  a = document.createElement('DIV')
  a.setAttribute('class', 'select-selected')
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
  dropdown.appendChild(a)
  b = document.createElement('DIV')
  b.setAttribute('class', 'select-items select-hide')
  for (j = 1; j < selElmnt.length; j++) {
    c = document.createElement('DIV')
    c.innerHTML = selElmnt.options[j].innerHTML
    c.addEventListener('click', function (e) {
      var y, i, k, s, h
      s = this.parentNode.parentNode.getElementsByTagName('select')[0]
      h = this.parentNode.previousSibling
      for (i = 0; i < s.length; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i
          h.innerHTML = this.innerHTML
          y = this.parentNode.getElementsByClassName('same-as-selected')
          for (k = 0; k < y.length; k++) {
            y[k].removeAttribute('class')
          }
          this.setAttribute('class', 'same-as-selected')
          break
        }
      }
      h.click()
    })
    b.appendChild(c)
  }
  dropdown.appendChild(b)
  a.addEventListener('click', function (e) {
    e.stopPropagation()
    // console.log(this)
    closeAllSelect(this, vue)
    this.nextSibling.classList.toggle('select-hide')
    this.classList.toggle('select-arrow-active')
  })
  a.addEventListener('change', function (e) {
    e.stopPropagation()
    // console.log(this)
    closeAllSelect(this, vue)
    this.nextSibling.classList.toggle('select-hide')
    this.classList.toggle('select-arrow-active')
  })
  // end
  return false
}

function bindSingleSelect () {
  // console.log(this)
  if (document.querySelector('.countries-select .select-selected')) document.querySelector('.countries-select .select-selected').remove()
  if (document.querySelector('.countries-select .select-items')) document.querySelector('.countries-select .select-items').remove()
  // if (document.querySelector('.countries-select .select-selected')) document.querySelector('.countries-select .select-selected').setAttribute('class', 'select-hide')
  // if (document.querySelector('.countries-select .select-items')) document.querySelector('.countries-select .select-items').setAttribute('class', 'select-hide')
  document.querySelector('.countries-select select').selectedIndex = 0
  var vue = this
  console.log('bindSingleSelect')
  var x, i, j, selElmnt, a, b, c
  x = document.getElementsByClassName('countries-select')
  for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName('select')[0]
    a = document.createElement('DIV')
    a.setAttribute('class', 'select-selected')
    console.log(selElmnt.options)
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
    x[i].appendChild(a)
    b = document.createElement('DIV')
    b.setAttribute('class', 'select-items select-hide')
    for (j = 1; j < selElmnt.length; j++) {
      c = document.createElement('DIV')
      c.innerHTML = selElmnt.options[j].innerHTML
      c.addEventListener('click', function (e) {
        var y, i, k, s, h
        s = this.parentNode.parentNode.getElementsByTagName('select')[0]
        h = this.parentNode.previousSibling
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i
            h.innerHTML = this.innerHTML
            y = this.parentNode.getElementsByClassName('same-as-selected')
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute('class')
            }
            this.setAttribute('class', 'same-as-selected')
            break
          }
        }
        h.click()
      })
      b.appendChild(c)
    }
    x[i].appendChild(b)
    a.addEventListener('click', function (e) {
      e.stopPropagation()
      console.log('click')
      closeAllSelect(this, vue)
      this.nextSibling.classList.toggle('select-hide')
      this.classList.toggle('select-arrow-active')
    })
    a.addEventListener('change', function (e) {
      e.stopPropagation()
      console.log('change')
      closeAllSelect(this, vue)
      this.nextSibling.classList.toggle('select-hide')
      this.classList.toggle('select-arrow-active')
    })
  }
}
function bindSelect () {
  // console.log(this)
  var vue = this
  console.log('bindSelect')
  var x, i, j, selElmnt, a, b, c
  x = document.getElementsByClassName('custom-select')
  for (i = 0; i < x.length; i++) {
    selElmnt = x[i].getElementsByTagName('select')[0]
    a = document.createElement('DIV')
    a.setAttribute('class', 'select-selected')
    a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML
    x[i].appendChild(a)
    b = document.createElement('DIV')
    b.setAttribute('class', 'select-items select-hide')
    for (j = 1; j < selElmnt.length; j++) {
      c = document.createElement('DIV')
      c.innerHTML = selElmnt.options[j].innerHTML
      c.addEventListener('click', function (e) {
        var y, i, k, s, h
        s = this.parentNode.parentNode.getElementsByTagName('select')[0]
        h = this.parentNode.previousSibling
        for (i = 0; i < s.length; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i
            h.innerHTML = this.innerHTML
            y = this.parentNode.getElementsByClassName('same-as-selected')
            for (k = 0; k < y.length; k++) {
              y[k].removeAttribute('class')
            }
            this.setAttribute('class', 'same-as-selected')
            break
          }
        }
        h.click()
      })
      b.appendChild(c)
    }
    x[i].appendChild(b)
    a.addEventListener('click', function (e) {
      e.stopPropagation()
      // console.log(this)
      closeAllSelect(this, vue)
      this.nextSibling.classList.toggle('select-hide')
      this.classList.toggle('select-arrow-active')
    })
    a.addEventListener('change', function (e) {
      e.stopPropagation()
      // console.log(this)
      closeAllSelect(this, vue)
      this.nextSibling.classList.toggle('select-hide')
      this.classList.toggle('select-arrow-active')
    })
  }
}

function closeAllSelect (elmnt, vue) {
  // console.log(vue)
  var x, y, i, j, arrNo = []
  x = document.getElementsByClassName('select-items')
  y = document.getElementsByClassName('select-selected')
  for (i = 0; i < y.length; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
      for (j = 0; j < $(elmnt).siblings().eq(0).find('option').length; j++) {
        if ($(elmnt).siblings().eq(0).find('option').eq(j).text() === $(elmnt).text()) {
          // console.log($(elmnt).siblings().eq(0).find('option').eq(j).val())
          // 將拿到的資料放到 vue object
          vue.register[$(elmnt).siblings().eq(0).data("model")] = $(elmnt).siblings().eq(0).find('option').eq(j).val()
        }
      }

      // console.log(vue.register)
      // console.log($(elmnt).siblings('rigister_slect').options)
      //birthYear birthMonth birthDay
      // vue.register.
    } else {
      y[i].classList.remove('select-arrow-active')
    }
  }
  for (i = 0; i < x.length; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add('select-hide')
    }
  }
}

export default {
  bindSelect,
  bindSingleSelect,
  bindOneDropdown,
  closeAllSelect (elmnt) {
    console.log(this)
    var x, y, i, arrNo = []
    x = document.getElementsByClassName('select-items')
    y = document.getElementsByClassName('select-selected')
    for (i = 0; i < y.length; i++) {
      if (elmnt == y[i]) {
        arrNo.push(i)
      } else {
        y[i].classList.remove('select-arrow-active')
      }
    }
    for (i = 0; i < x.length; i++) {
      if (arrNo.indexOf(i)) {
        x[i].classList.add('select-hide')
      }
    }
  }
}

// document.addEventListener('click', closeAllSelect)



// WEBPACK FOOTER //
// ./src/libs/jquery.select.js